module.exports = __webpack_public_path__ + "static/media/Boreal-Besties3.c9440b8f.jpg";